import { render, staticRenderFns } from "./MailingBossForm.vue?vue&type=template&id=44dd5bb0&scoped=true"
import script from "./MailingBossForm.vue?vue&type=script&lang=js"
export * from "./MailingBossForm.vue?vue&type=script&lang=js"
import style0 from "./MailingBossForm.vue?vue&type=style&index=0&id=44dd5bb0&prod&scoped=true&lang=scss"
import style1 from "./MailingBossForm.vue?vue&type=style&index=1&id=44dd5bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd5bb0",
  null
  
)

export default component.exports